<div class="cart-for-default" directive-max-on-screen-height="source" registerId="cart-popup">
    <div class="cart-for-default__inner" [ngClass]="{'is-scrolling': isScrolling}">

        <shared-cart-header (onOrderMoreClick)="handleOrderMoreClick($event)"
            (onCheckoutClick)="handleCheckoutClick($event)" directive-max-on-screen-height="height"
            registerId="cart-popup" subRegisterId="header" [total]="total$ | async"
            [pickupTimeLabel]="pickupTimeLabel$ | async" class="cart-for-default__header">
        </shared-cart-header>

        <shared-cart-items (onScrollToggle)="handleScrollToggle($event)" [maxHeight]="maxHeight"
            [cartItems]="cartItems$ | async" class="cart-for-default__items">
        </shared-cart-items>

        <shared-cart-footer directive-max-on-screen-height="height" registerId="cart-popup" subRegisterId="footer"
            (onClearCartClick)="handleClearCartClick($event)" class="cart-for-default__footer">
        </shared-cart-footer>

    </div>
</div>